<div class="incorrect-filters">
    <div class="incorrect-filters__content">
        <div class="incorrect-filters__title">{{ messages.titleText }}</div>
        <div class="incorrect-filters__hint">{{ messages.hintText }}</div>

        <button (click)="resetFilters()"
                type="button"
                class="incorrect-filters__reset-button">
            {{ messages.resetFiltersText }}
        </button>
    </div>
</div>
